import { Injectable } from '@angular/core';
import { Guid } from '@fitscovery/common/types';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { PaymentIntent } from '../models';
import { CreatePaymentIntent, GetPaymentIntentFromProvider } from '../actions';
import { ApiPaymongoService } from '../services';

export interface PaymentStateModel {
  paymentIntentId: string | Guid;
  paymentProviderPaymentId: string;
  clientKey: string;
  currentPaymentIntentInfo: PaymentIntent | null
}

export const paymentDefaults: PaymentStateModel = {
  clientKey: '',
  paymentIntentId: Guid.empty,
  paymentProviderPaymentId: '',
  currentPaymentIntentInfo: null
};

@State<PaymentStateModel>({
    name: 'payment',
    defaults: paymentDefaults
})

@Injectable()
export class PaymentState {

    constructor(private paymentService: ApiPaymongoService) { }

    @Selector()
    static getClientKey(state: PaymentStateModel): string {
      return state.clientKey;
    }

    @Selector()
    static getPaymentIntentId(state: PaymentStateModel): Guid | string {
      return state.paymentIntentId;
    }

    @Selector()
    static getpaymentProviderIntentId(state: PaymentStateModel): string {
      return state.paymentProviderPaymentId;
    }

    @Action(CreatePaymentIntent)
    async createPaymentIntent(ctx: StateContext<PaymentStateModel>, paymentIntent: CreatePaymentIntent): Promise<void> {
      const paymentIntentResponse = await this.paymentService.createPaymentIntent(paymentIntent.data.itemId, paymentIntent.data.paymentFor);
      ctx.patchState({
        clientKey: paymentIntentResponse.clientKey,
        paymentProviderPaymentId: paymentIntentResponse.paymentProviderIntentId,
        paymentIntentId: paymentIntentResponse.paymentIntentId
      });
    }

    @Action(GetPaymentIntentFromProvider)
    async getPaymentIntentFromProvider(ctx: StateContext<PaymentStateModel>, params: GetPaymentIntentFromProvider): Promise<void> {
      const paymentIntentInfo = await this.paymentService.getPaymentIntent(params.data.paymentProviderIntentId, params.data.clientKey!).toPromise();
      ctx.patchState({
        clientKey: paymentIntentInfo!.attributes.client_key,
        currentPaymentIntentInfo: paymentIntentInfo,
        paymentProviderPaymentId: paymentIntentInfo!.id
      });
    }
}
